module.exports = __webpack_public_path__ + "static/media/Hero-Inflatables.cb0fb613.jpg";